import React, { useState } from "react";
import { Routes, Route, Link } from "react-router-dom";

const Navbar = () => {

  const [currOpt, setCurrOpt] = useState("");
  console.log(currOpt);
  
  
  return (
    <div className="upbor">
      <header className="header" id="header">
        <nav className="navbar">
          <Link
            // className="navhover"
            className={`navhover ${currOpt == "" ? "activeNav" : ""}`}
            onClick={() => setCurrOpt("")}
            to="/"
          >
            Home
          </Link>
          <Link
            className={`navhover ${currOpt == "sp" ? "activeNav" : ""}`}
            onClick={() => setCurrOpt("sp")}
            to="/sp"
          >
            Summer Internship
          </Link>
          <Link
            className={`navhover ${currOpt == "minor" ? "activeNav" : ""}`}
            onClick={() => setCurrOpt("minor")}
            to="/minor"
          >
            Minor Projects
          </Link>
          <Link
            className={`navhover ${currOpt == "mp" ? "activeNav" : ""}`}
            onClick={() => setCurrOpt("mp")}
            to="/mp"
          >
            Major Projects
          </Link>
          <Link
            className={`navhover ${currOpt == "place" ? "activeNav" : ""}`}
            onClick={() => setCurrOpt("place")}
            to="/place"
          >
            Placements
          </Link>
          <Link
            className={`navhover ${currOpt == "hs" ? "activeNav" : ""}`}
            onClick={() => setCurrOpt("hs")}
            to="/hs"
          >
            Higher Studies
          </Link>
          <Link
            className={`navhover ${currOpt == "gallery" ? "activeNav" : ""}`}
            onClick={() => setCurrOpt("gallery")}
            to="/gallery"
          >
            Gallery 
          </Link>
        </nav>
      </header>
    </div>
  );
};

export default Navbar;
